// ColourUtils.js
// @ts-check
const COLOUR_CACHE = new Map();

const themeKey = () => document.documentElement.classList.contains('dark') ? 'dark' : 'light';  // handle different colours between light and dark mode

/**
 * Function to ensure a valid colour format is used
 * 
 * @param {string} colourName 
 * @returns string
 */
const normalise = (colourName) => {
  const normalisedColourName = (colourName || '').toLowerCase().replace(/^grey/, 'gray');
  return /-\d{3}$/.test(normalisedColourName) ? normalisedColourName : `${normalisedColourName}-500`;
};

/**
 * Resolve 'blue-500' | 'blue' | hex/rgb to a computed CSS colour.
 *
 * Caches per theme to allow for dark/light mode and reduce calculations.
 *
 * Cache should persist until full page refresh
 *
 * @param {string} token
 * @returns {string}
 */
export function resolveTokenToColour(token) {
  if (!token) return '';

  if (/^#|^rgb\(|^hsl\(/i.test(token)) return token; // already a colour

  if (typeof window === 'undefined' || !document?.body) return token; // Cannot use this approach with Server Side Rendering - there is no 'window'

  const normalisedToken = normalise(token);
  const key = `${themeKey()}:${normalisedToken}`;

  const cachedColour = COLOUR_CACHE.get(key);   // Attempt to get colour from cache if it has already been resolved
  if (cachedColour) return cachedColour;

  const el = document.createElement('span');    // use off screen element to get accurate colour
  el.className = `bg-${normalisedToken}`;
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  el.style.contain = 'paint';
  document.body.appendChild(el);
  const color = getComputedStyle(el).backgroundColor;
  el.remove();

  if (color) COLOUR_CACHE.set(key, color);
  return color || token;
}